import React from 'react';
import axios from 'axios';
import {Boton} from '../../comun/Index';
const FileDownload = require('js-file-download');

class Informes extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      showModalPeriodo:false,
      showModalPersona:false,
      showModalUsuario:false
    }
  }

  descargar(){
    const url = localStorage.getItem('apiUrl') + '/api/geo/informes/admin/formularios';
    const config = {
      headers:{
        authorization:sessionStorage.getItem('token')
      },
      responseType: 'blob'
    };
    axios.get(url, config)
    .then(res => {
      FileDownload(res.data, "info_formularios.csv");
    })
    .catch((e) =>{
      console.log(JSON.stringify(e))
    });
  }

  render(){
    const {} = this.state;
    return(
      <div className="TramitesTodo">
        <h3>Informes</h3>
        <h4>Descargar informe</h4>
        <div style={{display:'flex',flexDirection:'row', flexWrap:'wrap', justifyContent:'center', alignItems:'center'}}>
          <Boton
            backgroundColor="green"
            titulo="Descargar formularios"
            onClick={() => this.descargar()}
          />
        </div>
      </div>
    );
  }
}

export default Informes;
